import { useOpraAgreementModalController } from "./OpraAgreementModal.controller";
import { OpraAgreementModalPresentation } from "./OpraAgreementModal.pres";

export const OpraAgreementModal = () => {
  const { isOpen, onClose, onDismiss, onViewAndSign } =
    useOpraAgreementModalController();

  return (
    <OpraAgreementModalPresentation
      isOpen={isOpen}
      onClose={onClose}
      onDismiss={onDismiss}
      onViewAndSign={onViewAndSign}
    />
  );
};
